import { render, staticRenderFns } from "./SpikeSummaries.vue?vue&type=template&id=0f4384a5&scoped=true"
import script from "./SpikeSummaries.vue?vue&type=script&lang=js"
export * from "./SpikeSummaries.vue?vue&type=script&lang=js"
import style0 from "./SpikeSummaries.vue?vue&type=style&index=0&id=0f4384a5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4384a5",
  null
  
)

export default component.exports